import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

import { Alert, Card, Grid, CircularProgress } from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      await axios.post("https://api.sicamobile.com/api/atm/auth/admin/forgot", {
        email,
      });
      setSuccess("OTP sent to your email.");
      setTimeout(() => {
        navigate("/authentication/reset-password", { state: { email } });
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to send OTP.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDBox mb={1}>
            <img
              src="/logo.png" // make sure your logo path is correct (public/logo.png or imported)
              alt="Brand"
              style={{ height: "50px", objectFit: "contain" }}
            />
          </MDBox>
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Forgot Password
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <form onSubmit={handleSubmit}>
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </MDBox>
            <MDBox textAlign="right" mt={1}>
              <MDTypography
                variant="button"
                color="info"
                component={Link}
                to="/authentication/sign-in"
                sx={{ fontWeight: "medium", fontSize: "0.875rem" }}
              >
                Back to Login
              </MDTypography>
            </MDBox>

            {error && (
              <Grid item xs={12} mt={2}>
                <Alert severity="error">{error}</Alert>
              </Grid>
            )}
            {success && (
              <Grid item xs={12} mt={2}>
                <Alert severity="success">{success}</Alert>
              </Grid>
            )}

            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit" disabled={loading}>
                {loading ? <CircularProgress size={24} color="inherit" /> : "Send OTP"}
              </MDButton>
            </MDBox>
          </form>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default ForgotPassword;
